import { jsx as _jsx } from "react/jsx-runtime";
import ChartTooltipAction from "../index";
import Button from "../../Button";
import * as LS from "../../../lib/local-storage";
import { encodeSeriesFilters } from "../../../lib/charts/url-generation";
const storage = window.sessionStorage;
const compareSessionsKey = LS.makeKey("rum-compare-sessions");
export default function CompareSessionsAction({ type, point }) {
    const series = point.series.userOptions;
    if (series.metricQualified.substring(0, 4) !== "LUX|") {
        return null;
    }
    const filters = encodeSeriesFilters({ type, point });
    const compareSessions = () => {
        const existingSession = LS.getItem(compareSessionsKey, storage);
        if (existingSession) {
            // Compare these session filters to the stored session filters
            const url = new URL(`${window.SPEEDCURVE_CONFIG.accountUrl}/lux-compare/`, window.location.origin);
            url.searchParams.set("a", JSON.stringify(existingSession));
            url.searchParams.set("b", JSON.stringify(filters));
            // Remove the stored session filters before loading the RUM Compare dashboard
            storage.removeItem(compareSessionsKey);
            window.location.href = url.href;
        }
        else {
            // Store these session filters in session storage
            LS.setItem(compareSessionsKey, filters, storage);
            document.body.classList.add("compare-rum-notification");
        }
    };
    return (_jsx(ChartTooltipAction, { icon: "compare", children: _jsx(Button, { type: "button", variation: "link", onClick: compareSessions, children: _jsx("a", { children: "Compare Sessions" }) }) }));
}
